import script from "./floatMsgRenderV2.vue?vue&type=script&setup=true&lang=js"
export * from "./floatMsgRenderV2.vue?vue&type=script&setup=true&lang=js"

import "./floatMsgRenderV2.vue?vue&type=style&index=0&id=ee479c76&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee479c76"]])

export default __exports__